import { Api } from 'utils';

class InventoryService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/inventory',params),
		download: async (params?: any) => Api.createResponse('admin/inventory/download',params),
		save: async (params?: any) => Api.createResponse('admin/inventory/save',params),
		getProducts: async (params?: any) => Api.createResponse('admin/inventory/products',params),
	}

}

export default InventoryService;